"use client";

import { createContext, useContext, useRef } from "react";
import {
  createGlobalStore,
  getGlobalStoreInstance,
  setGlobalStoreInstance,
} from "@/app/globalStore/globalStore";
import { useStore } from "zustand";

type GlobalStore = ReturnType<typeof createGlobalStore>;

const ZustandContext = createContext<GlobalStore | null>(null);

export function ZustandProvider({ children }: { children: React.ReactNode }) {
  const storeRef = useRef<GlobalStore | null>(null);
  /* eslint-disable react-hooks/refs */
  if (!storeRef.current) {
    storeRef.current = getGlobalStoreInstance();
    setGlobalStoreInstance(storeRef.current);
  }

  return (
    /* eslint-disable react-hooks/refs */
    <ZustandContext.Provider value={storeRef.current!}>
      {children}
    </ZustandContext.Provider>
  );
}

// ✅ Hook to access Zustand store inside components
export function useGlobalStore<T>(
  selector: (state: ReturnType<typeof useStore<GlobalStore>>) => T,
): T {
  const store = useContext(ZustandContext);
  if (!store)
    throw new Error("ZustandProvider is missing in the component tree");
  return useStore(store, selector);
}
